/** Background Tasks result panel for `console_booking_edit` (dry run or apply). */
import { Alert, LinearProgress } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import type { BookingEditTaskResult } from '@/api/bookingEdit';
import * as bgtasksApi from '@/api/bgtasks';
import { ConsoleApiError } from '@/api/client';

import { BookingEditReport } from './BookingEditReport';

export function BookingEditResultPanel({ taskId }: { taskId: string }) {
  const q = useQuery({
    queryKey: ['booking-edit-result', taskId],
    queryFn: () => bgtasksApi.result(taskId),
    retry: (failureCount, error) =>
      failureCount < 10 && error instanceof ConsoleApiError && error.status === 404,
    retryDelay: 1200,
    staleTime: Infinity,
  });
  if (q.isLoading) return <LinearProgress />;
  if (q.isError || !q.data) return <Alert severity="warning">The run’s report is not available.</Alert>;
  return <BookingEditReport result={q.data.result as unknown as BookingEditTaskResult} taskId={taskId} />;
}
